import { render, staticRenderFns } from "./SapImportDetail.vue?vue&type=template&id=65465eda"
import script from "./SapImportDetail.vue?vue&type=script&lang=js"
export * from "./SapImportDetail.vue?vue&type=script&lang=js"
import style0 from "./SapImportDetail.vue?vue&type=style&index=0&id=65465eda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports